import React, { Fragment } from "react";
import { Tooltip, IconButton } from "@mui/material";

import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

const ViewButton = ({ ...props }) => {
  const { handelToggleView, userId, packageId, forms } = props;
  return (
    <Fragment>
      {forms && forms.length > 0 && (
        <Tooltip
          title="Hide Package Details"
          onClick={(e) => handelToggleView(e, packageId, userId, true)}
        >
          <IconButton aria-label="hidePackageDetails" size="large">
            <VisibilityOffIcon />
          </IconButton>
        </Tooltip>
      )}
      {forms && forms.length === 0 && (
        <Tooltip
          title="View Package Details"
          onClick={(e) => handelToggleView(e, packageId, userId, false)}
        >
          <IconButton aria-label="viewPackageDetails" size="large">
            <VisibilityIcon />
          </IconButton>
        </Tooltip>
      )}
    </Fragment>
  );
};

export default ViewButton;
